import React, { useState } from "react";
import "./datatable.scss";
import { Modal } from "react-bootstrap";
import { formatDate } from "../../../../utils/formatDate";
import axios from "axios";
import { toast } from "react-toastify";

const DataTable = ({ data, onEdit, fetchData, isAdmin }) => {
  const [show, setShow] = useState(false);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);

  const handleShow = (wallet) => {
    setSelectedWallet(wallet);
    setShow(true);
  };

  // Function to copy wallet address
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Wallet address copied to clipboard");
  };

  // Function to format wallet address for display
  const formatWalletAddress = (address) => {
    if (!address) return "";
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };

  // Function to get a subset of projects for display
  const displayProjects = (projects, max = 3) => {
    if (!projects || projects.length === 0) return [];
    return projects.slice(0, max);
  };

  // Function to get project icon based on project name
  const getProjectIcon = (projectName) => {
    // Map project names to their respective icons
    const projectIcons = {
      "DOP": "/assets/dop.svg",
      "GEMS": "/assets/gems.svg",
      "OAI": "/assets/oai.svg",
      // Add more mappings as needed
    };

    return projectIcons[projectName] || "/assets/default-project.svg";
  };

  // Function to handle edit
  const handleEdit = () => {
    if (selectedWallet) {
      onEdit(selectedWallet);
      handleClose();
    }
  };

  // Function to handle delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this whitelist wallet?")) {
      setLoading(true);
      try {
        const response = await axios.delete(`${process.env.REACT_APP_API_URL}/credit/whiltelist/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`
          }
        });

        if (response.data.statusCode === 201) {
          toast.success("Whitelist wallet deleted successfully");
          fetchData();
        } else {
          toast.error(response.data.message || "Failed to delete whitelist wallet");
        }
      } catch (error) {
        console.error("Error deleting whitelist wallet:", error);
        toast.error(error.response?.data?.message || "Failed to delete whitelist wallet");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <section className="datatable">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>
                  <div className="parent-tag">
                    Date Added
                    {/* <div className="filter-btn" style={{ cursor: "pointer" }}>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                          fill="#77868B"
                        />
                      </svg>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                          fill="#77868B"
                        />
                      </svg>
                    </div> */}
                  </div>
                </th>
                <th>Wallet Address</th>
                <th>Projects</th>
                { isAdmin &&   <th>Edit</th>}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((wallet) => (
                  <tr key={wallet._id}>
                    <td>
                      <div className="twice-text">
                        <h6>{formatDate(wallet.createdAt, "MM/DD/YYYY")}</h6>
                        <p>{formatDate(wallet.createdAt, "h:mm")}</p>
                      </div>
                    </td>
                    <td>
                      <p className="codepara">
                        {formatWalletAddress(wallet.by)}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="16"
                          viewBox="0 0 15 16"
                          fill="none"
                          onClick={() => copyToClipboard(wallet.by)}
                          style={{ cursor: "pointer" }}
                        >
                          <path
                            d="M9.41377 8.49985L9.44015 10.9497C9.46213 12.9913 8.65431 13.8167 6.61276 13.8386L4.1629 13.865C2.12135 13.887 1.29594 13.0792 1.27396 11.0376L1.24757 8.58778C1.22559 6.54623 2.03342 5.72082 4.07496 5.69884L6.52482 5.67246C8.56637 5.65047 9.39178 6.4583 9.41377 8.49985Z"
                            stroke="#77868B"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12.8757 4.96237L12.9021 7.41223C12.924 9.45378 12.1162 10.2792 10.0747 10.3012L9.43304 10.3081L9.41357 8.49985C9.39159 6.45831 8.56618 5.65048 6.52463 5.67246L4.7164 5.69194L4.70949 5.05031C4.6875 3.00876 5.49533 2.18335 7.53688 2.16136L9.98674 2.13498C12.0283 2.113 12.8537 2.92082 12.8757 4.96237Z"
                            stroke="#77868B"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </p>
                    </td>
                    <td>
                      <div className="mainprojects">
                        {displayProjects(wallet.projects).map((project, index) => (
                          <div className="innerproject" key={index}>
                            <div className="projectimg">
                              <img
                                src={`assets/${project.privateSale.toLowerCase()}.svg`}
                                alt={project.privateSale}
                                className="innerimg"
                              />
                            </div>
                            <p className="projectpara">{project.privateSale}</p>
                          </div>
                        ))}
                        {wallet.projects.length > 3 && (
                          <button onClick={() => handleShow(wallet)} className="morebtn">
                            +{wallet.projects.length - 3} More
                          </button>
                        )}
                      </div>
                    </td>
                    {isAdmin &&  <td>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        onClick={() => onEdit(wallet)}
                        style={{ cursor: "pointer" }}
                      >
                        <path
                          d="M14.81 9L15.75 9.94L6.67 19H5.75V18.08L14.81 9ZM18.41 3C18.16 3 17.9 3.1 17.71 3.29L15.88 5.12L19.63 8.87L21.46 7.04C21.85 6.65 21.85 6 21.46 5.63L19.12 3.29C18.92 3.09 18.67 3 18.41 3ZM14.81 6.19L3.75 17.25V21H7.5L18.56 9.94L14.81 6.19Z"
                          fill="#02171D"
                        />
                      </svg>
                    </td>}
                    <td>
                      <button onClick={() => handleShow(wallet)} className="viewbtn">
                        View Details
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No whitelist wallets found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      {selectedWallet && (
        <Modal show={show} onHide={handleClose} centered className="whitelistmodal">
          <Modal.Header closeButton>
            <Modal.Title>Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="walletmain">
              <p className="walletpara">Wallet Address</p>
              <h6 className="addresspara">{selectedWallet.by}</h6>
            </div>
            <div className="wallettable">
              <table>
                <thead>
                  <tr>
                    <th>Project</th>
                    <th className="text-center">Price</th>
                    <th className="text-center">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedWallet.projects.map((project, index) => (
                    <tr key={index}>
                      <td>
                        <div className="mainproject">
                          <div className="projectimg">
                            <img
                              src={`assets/${project.privateSale.toLowerCase()}.svg`}
                              alt={project.privateSale}
                              className="innerimg"
                            />
                          </div>
                          <p className="projectpara">{project.privateSale}</p>
                        </div>
                      </td>
                      <td className="text-center">${project.price}</td>
                      <td className="text-center">{project.tokens.toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="bottombtns">
              <button onClick={handleClose} className="btn-dull">
                Cancel
              </button>
              {isAdmin &&   <button onClick={handleEdit} className="btn-green">
                Edit Details
              </button>}
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default DataTable;

// import React, { useState } from "react";
// import "./datatable.scss";
// import { Modal, ProgressBar } from "react-bootstrap";
// import { formatDecimal } from "../../../../utils/formatDecimal";
// import { Api_Url } from "../../../../utils/ApiUrl";

// const DataTable = () => {
//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
//   const Api_Url = Api_Url;
//   const accessToken = localStorage.getItem("accessToken");
//   return (
//     <>
//       <section className="datatable">
//         <div className="table-responsive">
//           <table class="table">
//             <thead>
//               <tr>
//                 <th>
//                   <div className="parent-tag">
//                     Date Added
//                     <div className="filter-btn" style={{ cursor: "pointer" }}>
//                       <svg
//                         width="9"
//                         height="6"
//                         viewBox="0 0 9 6"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
//                           fill="#77868B"
//                         />
//                       </svg>
//                       <svg
//                         width="9"
//                         height="6"
//                         viewBox="0 0 9 6"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
//                           fill="#77868B"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                 </th>
//                 <th>Wallet Address</th>
//                 <th>Projects</th>
//                 <th>Edit</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td>
//                   <div className="twice-text">
//                     <h6>03/09/2024</h6>
//                     <p>5:14</p>
//                   </div>
//                 </td>
//                 <td>
//                   <p className="codepara">
//                     0x71C7656EC7ab88b098defB751B7401B5f6d89
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="15"
//                       height="16"
//                       viewBox="0 0 15 16"
//                       fill="none"
//                     >
//                       <path
//                         d="M9.41377 8.49985L9.44015 10.9497C9.46213 12.9913 8.65431 13.8167 6.61276 13.8386L4.1629 13.865C2.12135 13.887 1.29594 13.0792 1.27396 11.0376L1.24757 8.58778C1.22559 6.54623 2.03342 5.72082 4.07496 5.69884L6.52482 5.67246C8.56637 5.65047 9.39178 6.4583 9.41377 8.49985Z"
//                         stroke="#77868B"
//                         stroke-width="1.2"
//                         stroke-linecap="round"
//                         stroke-linejoin="round"
//                       />
//                       <path
//                         d="M12.8757 4.96237L12.9021 7.41223C12.924 9.45378 12.1162 10.2792 10.0747 10.3012L9.43304 10.3081L9.41357 8.49985C9.39159 6.45831 8.56618 5.65048 6.52463 5.67246L4.7164 5.69194L4.70949 5.05031C4.6875 3.00876 5.49533 2.18335 7.53688 2.16136L9.98674 2.13498C12.0283 2.113 12.8537 2.92082 12.8757 4.96237Z"
//                         stroke="#77868B"
//                         stroke-width="1.2"
//                         stroke-linecap="round"
//                         stroke-linejoin="round"
//                       />
//                     </svg>
//                   </p>
//                 </td>
//                 <td>
//                   <div className="mainprojects">
//                     <div className="innerproject">
//                       <div className="projectimg">
//                         <img src="/assets/dop.svg" alt="innerimg" className="innerimg" />
//                       </div>
//                       <p className="projectpara">DOP</p>
//                     </div>
//                     <div className="innerproject">
//                       <div className="projectimg">
//                         <img src="/assets/gems.svg" alt="innerimg" className="innerimg" />
//                       </div>
//                       <p className="projectpara">GEMS</p>
//                     </div>
//                     <div className="innerproject">
//                       <div className="projectimg">
//                         <img src="/assets/oai.svg" alt="innerimg" className="innerimg" />
//                       </div>
//                       <p className="projectpara">OAI</p>
//                     </div>
//                     <button onClick={handleShow} className="morebtn">+2 More</button>
//                   </div>
//                 </td>
//                 <td>
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="25"
//                     height="24"
//                     viewBox="0 0 25 24"
//                     fill="none"
//                   >
//                     <path
//                       d="M14.81 9L15.75 9.94L6.67 19H5.75V18.08L14.81 9ZM18.41 3C18.16 3 17.9 3.1 17.71 3.29L15.88 5.12L19.63 8.87L21.46 7.04C21.85 6.65 21.85 6 21.46 5.63L19.12 3.29C18.92 3.09 18.67 3 18.41 3ZM14.81 6.19L3.75 17.25V21H7.5L18.56 9.94L14.81 6.19Z"
//                       fill="#02171D"
//                     />
//                   </svg>
//                 </td>
//                 <td>
//                   <button onClick={handleShow} className="viewbtn">View Details</button>
//                 </td>
//               </tr>
//               </tbody>
//            </table>
//         </div>
//       </section>


//       <Modal show={show} onHide={handleClose} centered className="whitelistmodal">
//         <Modal.Header closeButton>
//           <Modal.Title>Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="walletmain">
//             <p className="walletpara">Wallet Address</p>
//             <h6 className="addresspara">0x71C7656EC7ab88b098defB751B7401B5f6d89</h6>
//           </div>
//           <div className="wallettable">
//             <table>
//               <thead>
//                 <th>
//                 Project
//                 </th>
//                 <th className="text-center">
//                 Price
//                 </th>
//                 <th className="text-center">
//                 Amount
//                 </th>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td>
//                       <div className="mainproject">
//                         <div className="projectimg">
//                           <img src="/assets/dop.svg" alt="innerimg" className="innerimg" />
//                         </div>
//                         <p className="projectpara">DOP</p>
//                       </div>
//                     </td>
//                     <td className="text-center">$0.01</td>
//                     <td className="text-center">50,789</td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="mainproject">
//                         <div className="projectimg">
//                           <img src="/assets/gems.svg" alt="innerimg" className="innerimg" />
//                         </div>
//                         <p className="projectpara">GEMS</p>
//                       </div>
//                     </td>
//                     <td className="text-center">$0.01</td>
//                     <td className="text-center">50,789</td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="mainproject">
//                         <div className="projectimg">
//                           <img src="/assets/oai.svg" alt="innerimg" className="innerimg" />
//                         </div>
//                         <p className="projectpara">OAI</p>
//                       </div>
//                     </td>
//                     <td className="text-center">$0.01</td>
//                     <td className="text-center">50,789</td>
//                   </tr>
//                 </tbody>
//             </table>
//           </div>
//           <div className="bottombtns">
//             <button onClick={handleClose} className="btn-dull">Cancel</button>
//             <button className="btn-green">Edit Details</button>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default DataTable;
